import { ApiCreditCardsResponse } from "@/api/creditCard";

import { FilterOptions } from "../typing";

/**
 * 根据数据列表获取筛选项
 */
export const useFilterOptions = (props: {
  category?: ApiCreditCardsResponse["categories"];
  banks?: ApiCreditCardsResponse["banks"];
}): FilterOptions => {
  const { category = [], banks = [] } = props;

  return {
    benefitsOptions: [],
    categoryOptions: category.map((item) => ({ value: String(item.id), label: item.name })),
    bankProgramsOptions: banks.map((item) => ({ value: String(item.id), label: item.name })),
    annualFeeOptions: [
      {
        value: "-1",
        label: "Any",
      },
      {
        value: "0",
        label: "No Annual Fee",
      },
      {
        value: "1",
        label: "≤ $100",
      },
      {
        value: "2",
        label: "> $100",
      },
    ],
  };
};
